const arrayUtils = {
    getDropdownItemName(list, value) {
        if (!list) {
            return "Error";
        }
        list = list.filter(item => item.id === value || item.guid === value);
        if (list.length === 1)
            return list[0].name;
        return "<Missing value>";
    },

    getArrayPropertyTotals(array, property) {
        return array.reduce(function (a, b) {
            return a + b[property];
        }, 0);
    },

    getArrayPropertyMaximum(array, property) {
        return Math.max.apply(Math, array.map(function (o) {
            return o[property];
        }))
    },

    getArrayPropertyMinimum(array, property) {
        return Math.min.apply(Math, array.map(function (o) {
            return o[property];
        }))
    },

    objectArrayContainsValue(array, property, value) {
        return array.filter(e => e[property] === value).length > 0;
    },

    filterObjectArrayByValue(array, property, value) {
        return array.filter(e => e[property].toLowerCase().indexOf(value.toLowerCase()) !== -1);
    },

    filterVonAccountArrayByValue(array, value) {
        return array.filter(e => e.roles && e.roles.some(p => p.productName.toLowerCase().includes(value.toLowerCase()) || e.roles.some(r => r.role.toLowerCase().includes(value.toLowerCase()))));
    }
};

export default arrayUtils;
